"use client"

import Icon from "@ant-design/icons"
import type { GetProps } from "antd"
import type { SVGProps } from "react"

const FLIGHTS_PATH =
  "M85.48,105.64c-5.06-4.48-4.66-12.5.81-16.46,14.54-10.52,28.48-20.68,42.8-30.28,2.59-1.73,8.41-.41,11.9,1.24,57.56,27.26,114.98,54.8,172.44,82.28,17.03,8.14,34.2,16.02,51.04,24.54,5.44,2.75,9.18,2.31,13.86-1.45,25.71-20.64,51.5-41.19,77.57-61.37,23.47-18.18,50.2-28.43,79.97-29.29,21.22-.61,32.5,12.2,29.55,33.31-3.06,21.9-11.49,40.97-29.88,55.06-29.99,22.98-59.31,46.83-89.2,69.96-5.92,4.58-8.2,9.08-7.33,16.73,8.85,78.03,17.12,156.13,26.13,234.14,1.24,10.73-.49,17.67-10,24.02-12.43,8.3-24.06,17.79-36.52,27.61-4.12,3.25-10.2,1.91-12.57-2.78-32.38-64.06-64.54-127.69-97.16-192.21-.82-1.62-2.92-2.1-4.36-1-9.41,7.19-18.38,14.01-27.3,20.9-27.56,21.29-54.99,42.75-82.72,63.8-5.08,3.86-6.59,7.69-5.85,13.94,2.51,21.34,4.08,42.79,6.69,64.11.79,6.47-.85,10.25-6.12,13.82-6.27,4.24-12.36,8.76-18.79,13.58-5.97,4.47-14.52,2.64-18.14-3.89-10.17-18.32-20.2-36.39-30.4-54.78-.71-1.28-2.28-1.84-3.64-1.29-5.56,2.24-10.82,4.37-16.83,6.79-1.27.51-2.73.06-3.49-1.08-8.38-12.51-17.56-24.92-24.71-38.41-2.25-4.24.83-12.2,3.15-17.76,3.6-8.62,2.53-14.68-4.34-21.53-11.82-11.78-22.99-24.21-34.72-37.08-4.92-5.39-4.09-13.86,1.78-18.2,7.1-5.25,13.98-10.28,21.12-14.9,2.38-1.54,7.07-.54,10.34.45,21.6,6.59,43.03,13.71,64.69,20.08,3.59,1.06,9.12.66,11.9-1.47,36.76-28.16,73.18-56.75,109.67-85.27.12-.09.22-.2.32-.33.89-1.16.65-2.84-.45-3.81-56.68-50.23-113.46-100.55-171.21-151.73Z"

type CustomIconComponentProps = GetProps<typeof Icon>

export type FlightsIconProps = Partial<CustomIconComponentProps> & {
  color?: string
  strokeWidth?: number
}

type FlightsSvgProps = SVGProps<SVGSVGElement> & {
  color?: string
  strokeWidth?: number
}

const FlightsSvg = ({
  color = "currentColor",
  strokeWidth = 26,
  ...props
}: FlightsSvgProps) => (
  <svg
    viewBox="0 0 600 600"
    width="1em"
    height="1em"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d={FLIGHTS_PATH}
      fill="none"
      stroke={color}
      strokeMiterlimit={10}
      strokeWidth={strokeWidth}
    />
  </svg>
)

const FlightsIcon = ({ color, strokeWidth, ...props }: FlightsIconProps) => (
  <Icon
    component={(svgProps: SVGProps<SVGSVGElement>) => (
      <FlightsSvg
        {...svgProps}
        color={color}
        strokeWidth={strokeWidth ?? (typeof svgProps.strokeWidth === "number" ? svgProps.strokeWidth : 26)}
      />
    )}
    {...props}
  />
)

export default FlightsIcon
